export default __webpack_public_path__ + "static/media/no_data.2b7041f2.svg";